import { Button } from "@/components/ui/button";
import { Languages } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageProvider";

export function LanguageToggle() {
  const { locale, toggleLocale } = useLanguage();
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLocale}
      className="rounded-full gap-2"
      aria-label="Toggle language"
    >
      <Languages className="h-4 w-4" />
      {locale === "ar" ? "EN" : "العربية"}
    </Button>
  );
}
